import gql from 'graphql-tag';
const I_KEYBOARDING_ACTIVITY_KEYBOARD_FRAGMENT = gql `
  fragment IKeyboardingActivityKeyboardFragment on IKeyboardingActivityKeyboard {
    keyboardId
    keyboard {
      id
      type
      keyboardType
      roofs
      characters
      showNumbers
    }
  }
`;
export default I_KEYBOARDING_ACTIVITY_KEYBOARD_FRAGMENT;
